<template>
  <a data-test-header-menu-item :href="computedUrl" @click="$emit('click')">
    <slot />
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="inherit"
        d="M14.7223 17.3C14.5389 17.1167 14.4473 16.8833 14.4473 16.6C14.4473 16.3167 14.5389 16.0833 14.7223 15.9L18.6223 12L14.7223 8.09999C14.5389 7.91665 14.4473 7.68332 14.4473 7.39999C14.4473 7.11665 14.5389 6.88332 14.7223 6.69999C14.9056 6.51665 15.1389 6.42499 15.4223 6.42499C15.7056 6.42499 15.9389 6.51665 16.1223 6.69999L20.7223 11.3C20.8223 11.4 20.8933 11.5083 20.9353 11.625C20.9766 11.7417 20.9973 11.8667 20.9973 12C20.9973 12.1333 20.9766 12.2583 20.9353 12.375C20.8933 12.4917 20.8223 12.6 20.7223 12.7L16.1223 17.3C15.9389 17.4833 15.7056 17.575 15.4223 17.575C15.1389 17.575 14.9056 17.4833 14.7223 17.3Z"
      />
    </svg>
  </a>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CviHeaderMenuItem',
  props: {
    url: {
      type: String,
      default: () => ''
    },
    loggedInUrl: {
      type: String,
      default: () => ''
    },
    isLoggedIn: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    computedUrl(): string {
      if (!this.loggedInUrl) return this.url;

      return this.isLoggedIn ? this.loggedInUrl : this.url;
    }
  }
});
</script>
